export const generalActions = ['Rest', 'Search', 'Ready', 'split', 'join to']